export function trackCapiEvent(eventName: string): string {
  const id = crypto.randomUUID();
  fbq('track', eventName, {}, { eventID: id });
  return id;
}
